/**
 * Opening the command palette from anywhere.
 *
 * The palette is owned by the shell, because it draws over everything and
 * closing it has to put you back where you were. That left every other screen
 * with no way to ask for it - the chat list's "Find or start a conversation"
 * wants exactly the palette's search, and reimplementing that search in the
 * sidebar would be a second, worse copy of it.
 *
 * So: one function anyone can call, one shell that listens. The same shape the
 * profile panel and the crew panel use.
 */

const watchers = new Set<() => void>();

/** Asks the shell to open the palette. Does nothing if no shell is mounted. */
export function openPalette(): void {
  watchers.forEach((fn) => fn());
}

/** The shell subscribes once. Returns the unsubscribe, for an effect. */
export function onOpenPalette(fn: () => void): () => void {
  watchers.add(fn);
  return () => { watchers.delete(fn); };
}
